<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{ modalTitle }}</h3>
  <div class="header-actions">
    <i class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Loader -->
@if (showFormLoader) {
<div class="loading-container" style="text-align: center; padding: 50px;">
  <i style="color: #e12827; font-size: 36px;" class="fa fa-spinner fa-spin"></i>
</div>
}

<!-- Modal Body -->
<div class="modal-body no-body-scroll" [hidden]="minimise || showFormLoader">
  <ul class="nav nav-pills" role="tablist">
    @for (tab of tabs; track $index) {
<li [class.active]="activeTab === tab.id">
      <a (click)="onTabChange(tab.id); clearTabData(tab.id)" style="cursor: pointer;" class="btn-sm">
        {{ tab.name }}
      </a>
    </li>
}
  </ul>

  <div class="tab-content">
      <!-- Tab 0: 8865 Overview -->
      @if (activeTab === 0) {
<div class="tab-pane active">
        <h3 class="text-center">
          <b>Form 8865 Schedule P: Acquisitions, Dispositions, and Changes of Interests in a Foreign Partnership</b>
        </h3>

        <!-- Loading Spinner -->
        @if (showFormLoader) {
<div class="formLoader">
          <i class="fa fa-spinner fa-spin gt-refresh"></i>
        </div>
}

        <!-- Content when not loading -->
        @if (!showFormLoader) {
<div class="tables-container">
          <!-- Part I: Acquisitions -->
          @if (isStockAquistionDataPresent) {
<div>
            <div class="text-center section-header" (click)="stockAquistionCollapsed = !stockAquistionCollapsed">
              <a style="color:#fff; cursor: pointer;">
                Part I: Acquisitions (All amounts in U.S. Dollars)
              </a>
            </div>
            <br>

            @if (stockAquistionCollapsed) {
<div>
              <table class="table table-bordered custom-table">
                <thead>
                  <tr>
                    <th>Name, address, and identifying number of person from whom your interest was acquired</th>
                    <th>Date of acquisition (mm/dd/yyyy)</th>
                    <th>FMV of interest acquired</th>
                    <th>Basis in interest acquired</th>
                    <th>% of interest before acquisition</th>
                    <th>% of interest after acquisition</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  @for (item of acquistionObj; track $index) {
<tr>
                    <td>
                      {{ item.NAME_OF_PERSON_OR_BUSINESS }}
                      <div>{{ item.NAME_LINE_1 }} {{ item.NAME_LINE_2 }}</div>
                      <div>{{ item.COUNTRY === 'US' ? item.ADDRESS_LINE_1 : item['8865_P_STOCK_ACQUISITION_F_ADDR_1'] }}</div>
                      <div>{{ item.COUNTRY === 'US' ? item.ADDRESS_LINE_2 : item['8865_P_STOCK_ACQUISITION_F_ADDR_2'] }} {{ item.COUNTRY === 'US' ? item.CITY : item['8865_P_STOCK_ACQUISITION_F_CITY'] }}</div>
                      <div>{{ item.STATE?.CODE || (item.COUNTRY === 'US' ? item.STATE : item['8865_P_STOCK_ACQUISITION_F_STATE']) }}</div>
                      <div>{{ item.COUNTRY === 'US' ? item.ZIP_OR_POSTAL_CODE : item['8865_P_STOCK_ACQUISITION_F_ZIP'] }}</div>
                      <div>{{ item.COUNTRY }}</div>
                      <div>{{ item.VALUE }}</div>
                    </td>
                    <td>{{ item.DATE_OF_ACQUISITION | date:'MM/dd/yyyy' }}</td>
                    <td style="text-align: right">{{ item.FMV_OF_INTEREST_ACQUIRED | number }}</td>
                    <td style="text-align: right">{{ item.BASIS_IN_INTEREST_ACQUIRED | number }}</td>
                    <td style="text-align: right">{{ item.PERCENT_OF_INTEREST_BEFORE_ACQUISITION }}</td>
                    <td style="text-align: right">{{ item.PERCENT_OF_INTEREST_AFTER_ACQUISITION }}</td>
                    <td>
                      <button class="action-button edit-button" type="button" (click)="editSchedule(item)">Edit</button>
                      <button class="action-button delete-button" type="button" (click)="deleteSchedule(item)">Delete</button>
                    </td>
                  </tr>
}
                </tbody>
              </table>
            </div>
}
          </div>
}

          <!-- Part II: Dispositions -->
          @if (isStockDispositionDataPresent) {
<div>
            <div class="text-center section-header" (click)="stockDispositionCollapsed = !stockDispositionCollapsed">
              <a style="color:#fff; cursor: pointer;">
                Part II: Dispositions (All amounts in U.S. Dollars)
              </a>
            </div>
            <br>

            @if (stockDispositionCollapsed) {
<div>
              <table class="table table-bordered custom-table">
                <thead>
                  <tr>
                    <th>Name, address, and identifying number of person to whom your interest was disposed</th>
                    <th>Date of disposition (mm/dd/yyyy)</th>
                    <th>FMV of interest disposed</th>
                    <th>Basis in interest disposed</th>
                    <th>% of interest before disposition</th>
                    <th>% of interest after disposition</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  @for (item of dispositionObj; track $index) {
<tr>
                    <td>
                      {{ item.NAME_OF_PERSON_OR_BUSINESS }}
                      <div>{{ item.NAME_LINE_1 }} {{ item.NAME_LINE_2 }}</div>
                      <div>{{ item.COUNTRY === 'US' ? item.ADDRESS_LINE_1 : item['8865_P_STOCK_DISPOSITION_F_ADDR_1'] }}</div>
                      <div>{{ item.COUNTRY === 'US' ? item.ADDRESS_LINE_2 : item['8865_P_STOCK_DISPOSITION_F_ADDR_2'] }} {{ item.COUNTRY === 'US' ? item.CITY : item['8865_P_STOCK_DISPOSITION_F_CITY'] }}</div>
                      <div>{{ item.STATE?.CODE || (item.COUNTRY === 'US' ? item.STATE : item['8865_P_STOCK_DISPOSITION_F_STATE']) }}</div>
                      <div>{{ item.COUNTRY === 'US' ? item.ZIP_OR_POSTAL_CODE : item['8865_P_STOCK_DISPOSITION_F_ZIP'] }}</div>
                      <div>{{ item.COUNTRY }}</div>
                      <div>{{ item.VALUE }}</div>
                    </td>
                    <td>{{ item.DATE_OF_DISPOSITION | date:'MM/dd/yyyy' }}</td>
                    <td style="text-align: right">{{ item.FMV_OF_INTEREST_DISPOSED | number }}</td>
                    <td style="text-align: right">{{ item.BASIS_IN_INTEREST_DISPOSED | number }}</td>
                    <td style="text-align: right">{{ item.PERCENT_OF_INTEREST_BEFORE_DISPOSITION }}</td>
                    <td style="text-align: right">{{ item.PERCENT_OF_INTEREST_AFTER_DISPOSITION }}</td>
                    <td>
                      <button class="action-button edit-button" type="button" (click)="editSchedule(item)">Edit</button>
                      <button class="action-button delete-button" type="button" (click)="deleteSchedule(item)">Delete</button>
                    </td>
                  </tr>
}
                </tbody>
              </table>
            </div>
}
          </div>
}

          <!-- Part III: Change in Proportional Interest -->
          @if (isProportionalInterestPresent) {
<div>
            <div class="text-center section-header" (click)="ProportionalInterestPresentCollapsed = !ProportionalInterestPresentCollapsed">
              <a style="color:#fff; cursor: pointer;">
                Part III: Change in Proportional Interest (All amounts in U.S. Dollars)
              </a>
            </div>
            <br>

            @if (ProportionalInterestPresentCollapsed) {
<div>
              <table class="table table-bordered custom-table">
                <thead>
                  <tr>
                    <th>Description of Change</th>
                    <th>Date of Change</th>
                    <th>FMV of interest</th>
                    <th>Basis in interest</th>
                    <th>% of interest before change</th>
                    <th>% of interest after change</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  @for (item of proportionalInterestObj; track $index) {
<tr>
                    <td>{{ item.DESCRIPTION_OF_CHANGE }}</td>
                    <td>{{ item.DATE_OF_CHANGE | date:'MM/dd/yyyy' }}</td>
                    <td style="text-align: right">{{ item.FMV_OF_INTEREST | number }}</td>
                    <td style="text-align: right">{{ item.BASIS_IN_INTEREST | number }}</td>
                    <td style="text-align: right">{{ item.PERCENT_OF_INTEREST_BEFORE_CHANGE }}</td>
                    <td style="text-align: right">{{ item.PERCENT_OF_INTEREST_AFTER_CHANGE }}</td>
                    <td>
                      <button class="action-button edit-button" type="button" (click)="editSchedule(item)">Edit</button>
                      <button class="action-button delete-button" type="button" (click)="deleteSchedule(item)">Delete</button>
                    </td>
                  </tr>
}
                </tbody>
              </table>
            </div>
}
          </div>
}

          <!-- Part IV: Supplemental Information -->
          @if (isSupplementalInformationPresent) {
<div>
            <div class="text-center section-header" (click)="SupplementalInformationPresentcollapsed = !SupplementalInformationPresentcollapsed">
              <a style="color:#fff; cursor: pointer;">
                Part IV: Supplemental Information Required To Be Reported (see instructions)
              </a>
            </div>
            <br>

            @if (SupplementalInformationPresentcollapsed) {
<div>
              <div>
                <span>Enter any information required to be reported in Part I in greater detail. Identify the applicable column number next to the information entered in this section.<br>
                In addition, if you contributed property to a foreign partnership as part of a wider transaction, briefly describe the entire transaction.</span>
              </div>
              <br>
              <table class="table table-bordered custom-table">
                <thead>
                  <tr>
                    <th>Supplemental Information</th>
                    <th>Action</th>
                  </tr>
                </thead>
              <tbody>
                @for (item of supplementalObj; track $index) {
<tr>
                  <td>
                    <textarea cols="110" [disabled]="true" [(ngModel)]="item.SUPPLEMENTAL_INFORMATION" 
                              name="suppInfo_{{item.occurrence}}" maxlength="4000" rows="2" class="form-control"></textarea>
                  </td>
                  <td>
                    <button class="action-button edit-button" type="button" (click)="editSchedule(item)">Edit</button>
                  </td>
                </tr>
}
              </tbody>
            </table>
            </div>
}
          </div>
}
        </div>
}
      </div>
}

      <!-- Tab 1: Add new Acquisition -->
      @if (activeTab === 1) {
<div class="tab-pane active form-horizontal">
        <div>
          <h3 class="text-center"><b>Form 8865 Schedule P: Acquisition of interests</b></h3>
          <div class="info-header"><i class="fa fa-info-circle"></i> All amounts in U. S. Dollars</div>
        </div>

        <!-- Name Type -->
        <div class="form-group">
          <label class="col-md-6">Name of person/business from whom your interest was acquired:</label>
          <div class="col-md-6">
            <label class="radio-inline">
              <input type="radio" [(ngModel)]="selectedTabCData.NAME_OF_PERSON_OR_BUSINESS" 
                     name="nameTypeC" value="P" (change)="changeRadioButton(selectedTabCData.NAME_LINE_1, 'c')">
              Person
            </label>
            <label class="radio-inline">
              <input type="radio" [(ngModel)]="selectedTabCData.NAME_OF_PERSON_OR_BUSINESS" 
                     name="nameTypeC" value="B" (change)="changeRadioButton(selectedTabCData.NAME_LINE_2, 'c')">
              Business
            </label>
          </div>
        </div>

        <!-- Name Line 1 -->
        <div class="form-group">
          <label class="col-md-6">Name Line 1:</label>
          <div class="col-md-6">
            <input type="text" [(ngModel)]="selectedTabCData.NAME_LINE_1" name="nameLine1C" class="form-control">
          </div>
        </div>

        <!-- Name Line 2 -->
        <div class="form-group">
          <label class="col-md-6">Name Line 2 (allowed only if name/address type is Business):</label>
          <div class="col-md-6">
            <input type="text" [(ngModel)]="selectedTabCData.NAME_LINE_2" name="nameLine2C" 
                   class="form-control" [disabled]="selectedTabCData.NAME_OF_PERSON_OR_BUSINESS === 'P'">
          </div>
        </div>

        <!-- Country -->
        <div class="form-group">
          <label class="col-md-6">Country:</label>
          <div class="col-md-6">
            <select class="form-control" [(ngModel)]="selectedTabCData.COUNTRYCODE" name="countryC"
                    (change)="changeCountry(selectedTabCData.COUNTRYCODE?.COUNTRY_CODE, 'c')">
              <option [ngValue]="null">Select Country</option>
              @for (country of countries; track $index) {
<option [ngValue]="country">
                {{ country.COUNTRY_CODE }} - {{ country.COUNTRY_NAME }}
              </option>
}
            </select>
          </div>
        </div>

        <!-- Address Line 1 -->
        <div class="form-group">
          <label class="col-md-6">Address Line 1:</label>
          <div class="col-md-6">
            @if (!isUSCountry('c')) {
<input type="text" 
                   [(ngModel)]="selectedTabCData['8865_P_STOCK_ACQUISITION_F_ADDR_1']" 
                   name="addrLine1FC" class="form-control">
}
            @if (isUSCountry('c')) {
<input type="text" 
                   [(ngModel)]="selectedTabCData.ADDRESS_LINE_1" 
                   name="addrLine1C" class="form-control">
}
          </div>
        </div>

        <!-- Address Line 2 -->
        <div class="form-group">
          <label class="col-md-6">Address Line 2:</label>
          <div class="col-md-6">
            @if (!isUSCountry('c')) {
<input type="text" 
                   [(ngModel)]="selectedTabCData['8865_P_STOCK_ACQUISITION_F_ADDR_2']" 
                   name="addrLine2FC" class="form-control">
}
            @if (isUSCountry('c')) {
<input type="text" 
                   [(ngModel)]="selectedTabCData.ADDRESS_LINE_2" 
                   name="addrLine2C" class="form-control">
}
          </div>
        </div>

        <!-- City -->
        <div class="form-group">
          <label class="col-md-6">City:</label>
          <div class="col-md-6">
            @if (!isUSCountry('c')) {
<input type="text" 
                   [(ngModel)]="selectedTabCData['8865_P_STOCK_ACQUISITION_F_CITY']" 
                   name="cityFC" class="form-control">
}
            @if (isUSCountry('c')) {
<input type="text" 
                   [(ngModel)]="selectedTabCData.CITY" 
                   name="cityC" class="form-control">
}
          </div>
        </div>

        <!-- State -->
        <div class="form-group">
          <label class="col-md-6">State:</label>
          <div class="col-md-6">
            @if (isUSCountry('c')) {
<select class="form-control" [(ngModel)]="selectedTabCData.STATEOBJ" 
                    name="stateC" (change)="changeState(selectedTabCData.STATEOBJ, 'c')">
              <option [ngValue]="null">Select State</option>
              @for (state of states; track $index) {
<option [ngValue]="state">
                {{ state.CODE }} - {{ state.NAME }}
              </option>
}
            </select>
}
            @if (!isUSCountry('c')) {
<input type="text" 
                   [(ngModel)]="selectedTabCData['8865_P_STOCK_ACQUISITION_F_STATE']" 
                   name="stateFC" class="form-control">
}
          </div>
        </div>

        <!-- Zip Code -->
        <div class="form-group">
          <label class="col-md-6">Zip/Postal Code:</label>
          <div class="col-md-6">
            @if (isUSCountry('c')) {
<input type="text" [(ngModel)]="selectedTabCData.ZIP_OR_POSTAL_CODE" 
                   name="zipC" class="form-control" pattern="[0-9]*"
                   (ngModelChange)="validateZipCode($event, 'c')">
}
            @if (zip_invalid_c && isUSCountry('c')) {
<span class="form-error-container">Only Numbers Allowed</span>
}
            @if (!isUSCountry('c')) {
<input type="text" 
                   [(ngModel)]="selectedTabCData['8865_P_STOCK_ACQUISITION_F_ZIP']" 
                   name="zipFC" class="form-control">
}
          </div>
        </div>

        <!-- Identifying Number -->
        <div class="form-group">
          <label class="col-md-6">Identifying No.:</label>
          <div class="col-md-6">
            <div class="identifying-no-row">
              <input type="text" [(ngModel)]="selectedTabCData.DISVALUE" name="identifyInputC" 
                     class="form-control id-input" maxlength="10" (input)="uncheckedRadio('C')">
              <label class="radio-inline">
                <input type="radio" [(ngModel)]="selectedTabCData.VALUE" name="identifyC" 
                       value="APPLD FOR" (ngModelChange)="radioClicked('C', $event)"> Applied For
              </label>
              <label class="radio-inline">
                <input type="radio" [(ngModel)]="selectedTabCData.VALUE" name="identifyC" 
                       value="FOREIGNUS" (ngModelChange)="radioClicked('C', $event)"> Not Applicable
              </label>
            </div>
          </div>
        </div>

        <!-- Date of Acquisition -->
        <div class="form-group">
          <label class="col-md-6">Date of acquisition (mm/dd/yyyy):</label>
          <div class="col-md-6">
            <input type="date" class="form-control" 
                   [value]="formatDateForInput(selectedTabCData.DATE_OF_ACQUISITION)"
                   (input)="onDateInputChange($event, 1)"
                   name="dateOfAcquisition" required>
            @if (date_flag_acquisition) {
<span class="form-error-container">Date of Acquisition is required</span>
}
            @if (date_range_acquisition) {
<span class="form-error-container">
              You can only enter date between {{ rowData.TAX_YEAR_BEGIN | date:'MM/dd/yyyy' }} to {{ rowData.TAX_YEAR_END | date:'MM/dd/yyyy' }}
            </span>
}
          </div>
        </div>

        <!-- FMV of interest acquired -->
        <div class="form-group">
          <label class="col-md-6">FMV of interest acquired:</label>
          <div class="col-md-6">
            <input type="text" [(ngModel)]="selectedTabCData.FMV_OF_INTEREST_ACQUIRED" 
                   name="fmvAcquisition" class="form-control text-right" placeholder="0">
          </div>
        </div>

        <!-- Basis in interest acquired -->
        <div class="form-group">
          <label class="col-md-6">Basis in interest acquired:</label>
          <div class="col-md-6">
            <input type="text" [(ngModel)]="selectedTabCData.BASIS_IN_INTEREST_ACQUIRED" 
                   name="basisAcquisition" class="form-control text-right" placeholder="0">
          </div>
        </div>

        <!-- % of interest before acquisition -->
        <div class="form-group">
          <label class="col-md-6">% of interest before acquisition:</label>
          <div class="col-md-6">
            <input type="text" [(ngModel)]="selectedTabCData.PERCENT_OF_INTEREST_BEFORE_ACQUISITION" 
                   name="percentBeforeAcquisition" class="form-control text-right" maxlength="11" placeholder="0"
                   (ngModelChange)="validatePercentage($event, 'percent_before_acquisition')">
            @if (percent_before_acquisition_invalid) {
<span class="form-error-container">
              Invalid entry, Percentage interest has to be between 0 and 100%
            </span>
}
          </div>
        </div>

        <!-- % of interest after acquisition -->
        <div class="form-group">
          <label class="col-md-6">% of interest after acquisition:</label>
          <div class="col-md-6">
            <input type="text" [(ngModel)]="selectedTabCData.PERCENT_OF_INTEREST_AFTER_ACQUISITION" 
                   name="percentAfterAcquisition" class="form-control text-right" maxlength="11" placeholder="0"
                   (ngModelChange)="validatePercentage($event, 'percent_after_acquisition')">
            @if (percent_after_acquisition_invalid) {
<span class="form-error-container">
              Invalid entry, Percentage interest has to be between 0 and 100%
            </span>
}
          </div>
        </div>
      </div>
}

      <!-- Tab 2: Add new Disposition -->
      @if (activeTab === 2) {
<div class="tab-pane active form-horizontal">
        <div>
          <h3 class="text-center"><b>Form 8865 Schedule P: Disposition of interests</b></h3>
          <div class="info-header"><i class="fa fa-info-circle"></i> All amounts in U. S. Dollars</div>
        </div>

        <!-- Name Type -->
        <div class="form-group">
          <label class="col-md-6">Name of person/business who acquired your interest:</label>
          <div class="col-md-6">
            <label class="radio-inline">
              <input type="radio" [(ngModel)]="selectedTabDData.NAME_OF_PERSON_OR_BUSINESS" 
                     name="nameTypeD" value="P" (change)="changeRadioButton(selectedTabDData.NAME_LINE_1, 'd')">
              Person
            </label>
            <label class="radio-inline">
              <input type="radio" [(ngModel)]="selectedTabDData.NAME_OF_PERSON_OR_BUSINESS" 
                     name="nameTypeD" value="B" (change)="changeRadioButton(selectedTabDData.NAME_LINE_2, 'd')">
              Business
            </label>
          </div>
        </div>

        <!-- Name Line 1 -->
        <div class="form-group">
          <label class="col-md-6">Name Line 1:</label>
          <div class="col-md-6">
            <input type="text" [(ngModel)]="selectedTabDData.NAME_LINE_1" name="nameLine1D" class="form-control">
          </div>
        </div>

        <!-- Name Line 2 -->
        <div class="form-group">
          <label class="col-md-6">Name Line 2 (allowed only if name/address type is Business):</label>
          <div class="col-md-6">
            <input type="text" [(ngModel)]="selectedTabDData.NAME_LINE_2" name="nameLine2D" 
                   class="form-control" [disabled]="selectedTabDData.NAME_OF_PERSON_OR_BUSINESS === 'P'">
          </div>
        </div>

        <!-- Country -->
        <div class="form-group">
          <label class="col-md-6">Country:</label>
          <div class="col-md-6">
            <select class="form-control" [(ngModel)]="selectedTabDData.COUNTRYCODE" name="countryD"
                    (change)="changeCountry(selectedTabDData.COUNTRYCODE?.COUNTRY_CODE, 'd')">
              <option [ngValue]="null">Select Country</option>
              @for (country of countries; track $index) {
<option [ngValue]="country">
                {{ country.COUNTRY_CODE }} - {{ country.COUNTRY_NAME }}
              </option>
}
            </select>
          </div>
        </div>

        <!-- Address fields for Disposition (similar to Acquisition) -->
        <div class="form-group">
          <label class="col-md-6">Address Line 1:</label>
          <div class="col-md-6">
            @if (!isUSCountry('d')) {
<input type="text" 
                   [(ngModel)]="selectedTabDData['8865_P_STOCK_DISPOSITION_F_ADDR_1']" 
                   name="addrLine1FD" class="form-control">
}
            @if (isUSCountry('d')) {
<input type="text" 
                   [(ngModel)]="selectedTabDData.ADDRESS_LINE_1" 
                   name="addrLine1D" class="form-control">
}
          </div>
        </div>

        <div class="form-group">
          <label class="col-md-6">Address Line 2:</label>
          <div class="col-md-6">
            @if (!isUSCountry('d')) {
<input type="text" 
                   [(ngModel)]="selectedTabDData['8865_P_STOCK_DISPOSITION_F_ADDR_2']" 
                   name="addrLine2FD" class="form-control">
}
            @if (isUSCountry('d')) {
<input type="text" 
                   [(ngModel)]="selectedTabDData.ADDRESS_LINE_2" 
                   name="addrLine2D" class="form-control">
}
          </div>
        </div>

        <div class="form-group">
          <label class="col-md-6">City:</label>
          <div class="col-md-6">
            @if (!isUSCountry('d')) {
<input type="text" 
                   [(ngModel)]="selectedTabDData['8865_P_STOCK_DISPOSITION_F_CITY']" 
                   name="cityFD" class="form-control">
}
            @if (isUSCountry('d')) {
<input type="text" 
                   [(ngModel)]="selectedTabDData.CITY" 
                   name="cityD" class="form-control">
}
          </div>
        </div>

        <div class="form-group">
          <label class="col-md-6">State:</label>
          <div class="col-md-6">
            @if (isUSCountry('d')) {
<select class="form-control" [(ngModel)]="selectedTabDData.STATEOBJ" 
                    name="stateD" (change)="changeState(selectedTabDData.STATEOBJ, 'd')">
              <option [ngValue]="null">Select State</option>
              @for (state of states; track $index) {
<option [ngValue]="state">
                {{ state.CODE }} - {{ state.NAME }}
              </option>
}
            </select>
}
            @if (!isUSCountry('d')) {
<input type="text" 
                   [(ngModel)]="selectedTabDData['8865_P_STOCK_DISPOSITION_F_STATE']" 
                   name="stateFD" class="form-control">
}
          </div>
        </div>

        <div class="form-group">
          <label class="col-md-6">Zip/Postal Code:</label>
          <div class="col-md-6">
            @if (isUSCountry('d')) {
<input type="text" [(ngModel)]="selectedTabDData.ZIP_OR_POSTAL_CODE" 
                   name="zipD" class="form-control" pattern="[0-9]*"
                   (ngModelChange)="validateZipCode($event, 'd')">
}
            @if (zip_invalid_d && isUSCountry('d')) {
<span class="form-error-container">Only Numbers Allowed</span>
}
            @if (!isUSCountry('d')) {
<input type="text" 
                   [(ngModel)]="selectedTabDData['8865_P_STOCK_DISPOSITION_F_ZIP']" 
                   name="zipFD" class="form-control">
}
          </div>
        </div>

        <!-- Identifying Number -->
        <div class="form-group">
          <label class="col-md-6">Identifying No.:</label>
          <div class="col-md-6">
            <div class="identifying-no-row">
              <input type="text" [(ngModel)]="selectedTabDData.DISVALUE" name="identifyInputD" 
                     class="form-control id-input" maxlength="10" (input)="uncheckedRadio('D')">
              <label class="radio-inline">
                <input type="radio" [(ngModel)]="selectedTabDData.VALUE" name="identifyD" 
                       value="APPLD FOR" (ngModelChange)="radioClicked('D', $event)"> Applied For
              </label>
              <label class="radio-inline">
                <input type="radio" [(ngModel)]="selectedTabDData.VALUE" name="identifyD" 
                       value="FOREIGNUS" (ngModelChange)="radioClicked('D', $event)"> Not Applicable
              </label>
            </div>
          </div>
        </div>

        <!-- Date of Disposition -->
        <div class="form-group">
          <label class="col-md-6">Date of Disposition (mm/dd/yyyy):</label>
          <div class="col-md-6">
            <input type="date" class="form-control" 
                   [value]="formatDateForInput(selectedTabDData.DATE_OF_DISPOSITION)"
                   (input)="onDateInputChange($event, 2)"
                   name="dateOfDisposition" required>
            @if (date_flag_disposition) {
<span class="form-error-container">Date of Disposition is required</span>
}
            @if (date_range_disposition) {
<span class="form-error-container">
              You can only enter date between {{ rowData.TAX_YEAR_BEGIN | date:'MM/dd/yyyy' }} to {{ rowData.TAX_YEAR_END | date:'MM/dd/yyyy' }}
            </span>
}
          </div>
        </div>

        <!-- FMV/Basis/Percentage fields -->
        <div class="form-group">
          <label class="col-md-6">FMV of interest disposed:</label>
          <div class="col-md-6">
            <input type="text" [(ngModel)]="selectedTabDData.FMV_OF_INTEREST_DISPOSED" 
                   name="fmvDisposition" class="form-control text-right" placeholder="0">
          </div>
        </div>

        <div class="form-group">
          <label class="col-md-6">Basis in interest disposed:</label>
          <div class="col-md-6">
            <input type="text" [(ngModel)]="selectedTabDData.BASIS_IN_INTEREST_DISPOSED" 
                   name="basisDisposition" class="form-control text-right" placeholder="0">
          </div>
        </div>

        <div class="form-group">
          <label class="col-md-6">% of interest before disposition:</label>
          <div class="col-md-6">
            <input type="text" [(ngModel)]="selectedTabDData.PERCENT_OF_INTEREST_BEFORE_DISPOSITION" 
                   name="percentBeforeDisposition" class="form-control text-right" maxlength="10" placeholder="0"
                   (ngModelChange)="validatePercentage($event, 'percent_before_disposition')">
            @if (percent_before_disposition_invalid) {
<span class="form-error-container">
              Invalid entry, Percentage interest has to be between 0 and 100%
            </span>
}
          </div>
        </div>

        <div class="form-group">
          <label class="col-md-6">% of interest after disposition:</label>
          <div class="col-md-6">
            <input type="text" [(ngModel)]="selectedTabDData.PERCENT_OF_INTEREST_AFTER_DISPOSITION" 
                   name="percentAfterDisposition" class="form-control text-right" maxlength="10" placeholder="0"
                   (ngModelChange)="validatePercentage($event, 'percent_after_disposition')">
            @if (percent_after_disposition_invalid) {
<span class="form-error-container">
              Invalid entry, Percentage interest has to be between 0 and 100%
            </span>
}
          </div>
        </div>
      </div>
}

      <!-- Tab 3: Add new Change in Proportional Interest -->
      @if (activeTab === 3) {
<div class="tab-pane active form-horizontal">
        <div>
          <h3 class="text-center"><b>Form 8865 Schedule P: Change in Proportional Interest</b></h3>
          <div class="info-header"><i class="fa fa-info-circle"></i> All amounts in U. S. Dollars</div>
        </div>

        <!-- Date of Change -->
        <div class="form-group">
          <label class="col-md-6">Date of Change (mm/dd/yyyy):</label>
          <div class="col-md-6">
            <input type="date" class="form-control" 
                   [value]="formatDateForInput(selectedTabEData.DATE_OF_CHANGE)"
                   (input)="onDateInputChange($event, 3)"
                   name="dateOfChange" required>
            @if (date_flag_change) {
<span class="form-error-container">Date of Change is required</span>
}
            @if (date_range_change) {
<span class="form-error-container">
              You can only enter date between {{ rowData.TAX_YEAR_BEGIN | date:'MM/dd/yyyy' }} to {{ rowData.TAX_YEAR_END | date:'MM/dd/yyyy' }}
            </span>
}
          </div>
        </div>

        <!-- Description of Change -->
        <div class="form-group">
          <label class="col-md-6">Description Of Change:</label>
          <div class="col-md-6">
            <input type="text" [(ngModel)]="selectedTabEData.DESCRIPTION_OF_CHANGE" 
                   name="descOfChange" class="form-control" required 
                   (change)="changeDescription(selectedTabEData.DESCRIPTION_OF_CHANGE)">
            @if (desc_of_change) {
<span class="form-error-container">Description of Change is required</span>
}
          </div>
        </div>

        <!-- FMV/Basis/Percentage fields -->
        <div class="form-group">
          <label class="col-md-6">FMV of interest:</label>
          <div class="col-md-6">
            <input type="text" [(ngModel)]="selectedTabEData.FMV_OF_INTEREST" 
                   name="fmvInterest" class="form-control text-right" placeholder="0">
          </div>
        </div>

        <div class="form-group">
          <label class="col-md-6">Basis in interest:</label>
          <div class="col-md-6">
            <input type="text" [(ngModel)]="selectedTabEData.BASIS_IN_INTEREST" 
                   name="basisInterest" class="form-control text-right" placeholder="0">
          </div>
        </div>

        <div class="form-group">
          <label class="col-md-6">% of interest before change:</label>
          <div class="col-md-6">
            <input type="text" [(ngModel)]="selectedTabEData.PERCENT_OF_INTEREST_BEFORE_CHANGE" 
                   name="percentBeforeChange" class="form-control text-right" maxlength="10" placeholder="0"
                   (ngModelChange)="validatePercentage($event, 'percent_before_change')">
            @if (percent_before_change_invalid) {
<span class="form-error-container">
              Invalid entry, Percentage interest has to be between 0 and 100%
            </span>
}
          </div>
        </div>

        <div class="form-group">
          <label class="col-md-6">% of interest after change:</label>
          <div class="col-md-6">
            <input type="text" [(ngModel)]="selectedTabEData.PERCENT_OF_INTEREST_AFTER_CHANGE" 
                   name="percentAfterChange" class="form-control text-right" maxlength="10" placeholder="0"
                   (ngModelChange)="validatePercentage($event, 'percent_after_change')">
            @if (percent_after_change_invalid) {
<span class="form-error-container">
              Invalid entry, Percentage interest has to be between 0 and 100%
            </span>
}
          </div>
        </div>
      </div>
}

      <!-- Tab 4: Add new Supplemental Information -->
      @if (activeTab === 4) {
<div class="tab-pane active form-horizontal">
        <div>
          <h3 class="text-center"><b>Form 8865 Schedule P: Supplemental Information Required To Be Reported</b></h3>
          <div class="info-header">
            <i class="fa fa-info-circle"></i>
            Enter any information required to be reported in Part I in greater detail. Identify the applicable column number next to the information entered in this section.<br>
            In addition, if you contributed property to a foreign partnership as part of a wider transaction, briefly describe the entire transaction.
          </div>
        </div>

        <div class="form-group">
          <label class="col-md-6">Supplemental Information:</label>
          <div class="col-md-6">
            <textarea cols="110" [(ngModel)]="selectedTabFData.SUPPLEMENTAL_INFORMATION" 
                      name="supplementalInfo" maxlength="4000" rows="4" class="form-control"></textarea>
          </div>
        </div>
      </div>
}

  </div>
</div>

<!-- Modal Footer -->
<div class="modal-footer" [hidden]="minimise">
  @if (isActionTab()) {
<button class="btn btn-info btn-sm save-button" 
          type="button" 
         
          (click)="save()" 
          [disabled]="crudLoading">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
    Save
  </button>
}
  @if (isActionTab()) {
<button class="reset-button" 
          type="button" 
         
          (click)="reset()">
    Reset
  </button>
}
  <button class="btn btn-warning btn-sm cancel-button" 
          type="button" 
          (click)="cancel()">
    Cancel
  </button>
</div>



